import {
    ensureGlobalCXContextInit,
    initGlobalContext
} from './global-cx-context.utils';
import { GlobalCXContext } from '~/components/ClientExperience/providers/global-context/global-cx.context';

let globalContext: GlobalCXContext = null;

export function init(): GlobalCXContext {
    globalContext = initGlobalContext({ currentGlobalContext: globalContext });

    return globalContext;
}

// for test cleanup
export function cleanup() {
    globalContext = null;
}

export function getGlobalCXContext() {
    ensureGlobalCXContextInit(globalContext);

    return globalContext;
}
